import React, { Component } from 'react';
import { ArrowRight, MessageCircle, Users, Handshake, FileCheck, Gift, CheckCircle } from 'lucide-react';
const steps = [{
  icon: MessageCircle,
  text: 'No te pedimos que decidas nada hoy.',
  bold: false
}, {
  icon: Users,
  text: 'Solo cuéntanos qué tienes en mente: qué espacio quieres transformar, dónde estás, y qué resultado buscas.',
  bold: false
}, {
  icon: Handshake,
  text: 'Un miembro del equipo te responderá directamente. Sin robots. Sin presión.',
  bold: false
}, {
  icon: FileCheck,
  text: 'Si tiene sentido seguir, acordamos una asesoría.',
  bold: false
}, {
  icon: Gift,
  text: 'Si decides continuar con la obra, esa asesoría te la descontamos del total.',
  bold: false
}, {
  icon: CheckCircle,
  text: 'El primer paso no cuesta nada. Y puede ahorrarte mucho.',
  bold: true
}];
export function FinalCTASection() {
  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hola, ESCRÍBENOS — CUÉNTANOS QUÉ QUIERES HACER');
    window.open(`https://wa.me/573182434499?text=${message}`, '_blank');
  };
  return <section id="contact" className="bg-[#E8621A] py-12 md:py-20" style={{
    contentVisibility: 'auto'
  }} data-id="element-36">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6" data-id="element-37">
        <div className="text-center mb-8 md:mb-12" data-id="element-38">
          <h2 className="text-[26px] md:text-[40px] font-bold text-white mb-4 md:mb-6" style={{
          lineHeight: '1.2',
          letterSpacing: '-0.02em'
        }} data-id="element-39">
            El primer paso es una conversación. Nada más.
          </h2>
        </div>

        {/* Content with Step Icons */}
        <div className="max-w-3xl mx-auto mb-8 md:mb-12 space-y-4 md:space-y-6" data-id="element-40">
          {steps.map((step, index) => {
          const Icon = step.icon;
          return <div key={index} className="flex items-start gap-3 md:gap-4" data-id="element-41">
                {/* Icon Circle - minimum 44px tap target */}
                <div className="flex-shrink-0 w-11 h-11 md:w-14 md:h-14 bg-white/20 rounded-full flex items-center justify-center" data-id="element-42">
                  <Icon className="w-6 h-6 md:w-7 md:h-7 text-white" data-id="element-43" />
                </div>
                {/* Text */}
                <p className={`text-white text-[15px] md:text-[17px] ${step.bold ? 'font-bold' : 'font-normal'} pt-1 md:pt-2`} style={{
              lineHeight: '1.6'
            }} data-id="element-44">
                  {step.text}
                </p>
              </div>;
        })}
        </div>

        {/* CTA BUTTON - full width on mobile, min-height 52px */}
        <div className="text-center" data-id="element-45">
          <button onClick={handleWhatsApp} className="w-full md:w-auto bg-white text-[#E8621A] px-8 md:px-16 py-4 md:py-6 rounded-full font-bold uppercase text-[13px] md:text-[15px] hover:bg-white/90 transition-all shadow-2xl hover:scale-105 flex md:inline-flex items-center justify-center gap-3 md:gap-4 min-h-[52px]" style={{
          lineHeight: '1',
          letterSpacing: '0.08em'
        }} data-id="element-46">
            ESCRÍBENOS — CUÉNTANOS QUÉ QUIERES HACER
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6" data-id="element-47" />
          </button>
        </div>
      </div>
    </section>;
}